<al-description-modal></al-description-modal>

<ng-container *ngIf="LinkSettings$ | async as groupedLinkSettings">
	<dx-accordion [collapsible]="true">
		<dxi-item title="General">
			<div class="card-body">
				<div *ngIf="formGroupCollection">
					<al-link-edit-general [formGroup]="formGroupCollection.get('general')" [link]="link"></al-link-edit-general>
				</div>
			</div>
		</dxi-item>
		<dxi-item title="Application logins" >
			<div class="card-body">
				<al-link-edit-login-details [link]="link" [fromAppName]="linkInfo.fromDName" [toAppName]="linkInfo.toDName" [linkInfo]="linkInfo">
				</al-link-edit-login-details>
			</div>
		</dxi-item>
		<ng-container *ngFor="let sectionSettings of groupedLinkSettings | settingSectionSortPipe">
			<dxi-item title="{{ toCaption(sectionSettings.section) }}">
				<div class="card-body">
					<ng-container *ngIf="isAdminSubject | async">
						<button  class="btn btn-primary btn-sm" (click)="openAdminSettingManagementMenu()">[Admin] Settings management</button>
					</ng-container>
					<ng-container *ngIf="sectionSettings.defaultAccess as accessGroup">
						<ng-container *ngIf="linkSettingGroupings | async as groupings">
							<fieldset *ngFor="let group of accessGroup.groups | settingGroupNameSortPipe: groupings">
								<legend>{{ group.name ? group.name : "Unassigned" }}</legend>
								<ng-container *ngIf="accessGroup.formGroup">
									<div>
										<al-link-edit-settings [dateFormat]="dateFormat" [setting]="setting" [form]="accessGroup.formGroup" [descriptionModal]="descriptionModal"
											*ngFor="let setting of group.settings | settingSortPipe">
										</al-link-edit-settings>
									</div>
								</ng-container>
							</fieldset>
						</ng-container>
					</ng-container>
				</div>
				<dx-accordion noDataText="">
					<dxi-item *ngFor="let accessGroup of sectionSettings.accessGroups">
						<ng-container *ngIf="linkSettingGroupings | async as groupings">
							<fieldset *ngFor="let group of accessGroup.groups | settingGroupNameSortPipe: groupings">
								<legend>{{ group.name ? group.name : "General" }}</legend>
								<div class="settings-grid">
									<div class="card-body">
										<al-link-edit-settings [dateFormat]="dateFormat" [setting]="setting" [form]="accessGroup.formGroup" [descriptionModal]="descriptionModal"
											*ngFor="let setting of group.settings | settingSortPipe">
										</al-link-edit-settings>
									</div>
								</div>
							</fieldset>
						</ng-container>
					</dxi-item>
				</dx-accordion>
			</dxi-item>
		</ng-container>
		<!-- *ngIf="!this.linkInfo.frontendPage" -->
		<dxi-item title="Log">
			<div class="card-body">
				<al-link-log-settings [formGroup]="formGroupCollection.get('log')" [link]="link"></al-link-log-settings>
			</div>
		</dxi-item>
	</dx-accordion>
</ng-container>

<app-shell-link-edit-setting-grouping-admin></app-shell-link-edit-setting-grouping-admin>
